import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-capacity',
  templateUrl: './guest-capacity.component.html',
  styleUrls: ['./guest-capacity.component.scss'],
  standalone: false
})
export class GuestCapacityComponent implements OnInit {
  @Input() adults: number;
  @Input() children: number;
  @Input() maxGuests: number;

  constructor() {}

  ngOnInit(): void {}

  createArray(length: number) {
    return new Array(length);
  }
}
